
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Table } from 'antd';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { PdfRegistros } from '../../components/PdfRegistros/PdfRegistros';

const VerRegistros = () => {
  const location = useLocation();
  const data = location.state?.data || [];

  const columns = data.length > 0 ? Object.keys(data[0]).map(key => ({
    title: key,
    dataIndex: key,
    key,
  })) : [];

  return (
    <div style={{ padding: 24 }}>
      <h2>Registros de Inventario</h2>
      <div style={{ marginBottom: 32, border: '1px solid #ccc', minHeight: 500 }}>
        <PDFViewer width="100%" height={500}>
          <PdfRegistros data={data} />
        </PDFViewer>
      </div>
    </div>
  );
};

export default VerRegistros;
